import { Grid, Tooltip, Typography } from '@mui/material'
import React from 'react'
import LogoutButtonIcon from "./LogoutButton.png"
import "./LandingPage.css"
const AppBar = ({handleLogout,location}) => {
  return (
    <div style={{zIndex:10, position: "absolute", top: 0, right: 0, display: "flex", gap: 10, alignItems: "center", width: "100%", justifyContent: "space-between", backgroundColor: "transparent", boxShadow: "1px 1px 600px #1A5D87", padding: "8px 0px", minHeight: "55px" }}>
        <Grid xs={6} sx={{ pl: 2 }}>
          <img src={location?.state?.logo} alt='' style={{ Width: "30px", maxHeight: "60px" }} />
        </Grid>
        <Grid sx={{ display: "flex", gap: 2, pr: 2, color: "gray" }}>
          <Typography sx={{
            cursor: "pointer",
             fontSize: "16px",
              border: "2px solid white",
               borderRadius: 2, padding: "0px 40px", display: "flex", alignItems: "center", color:"white",
        
          }}>Welcome, {localStorage.getItem("userName")}</Typography>
          <Tooltip title="Logout">
         
            <img 
            className='logout_button'
            style={{cursor:"pointer"}}
            src={LogoutButtonIcon}
            onClick={handleLogout}
             alt=''/>
          </Tooltip>
        </Grid>
      </div>
  )
}

export default AppBar